import axios from 'axios'

export const hfTicketsByCustomerId = ({ customerId }) => {
    return axios({
        method: `post`,
        url: `/bq/customer-dashboard/fetch-customer-hf-tickets-by-email`,
        data: {
            customerId
        }
    })
}
